// extracted by mini-css-extract-plugin
export default {"container":"Document_container__rkJoB","innerContainer":"Document_innerContainer__VjZhn","upload":"Document_upload__sHT2j"};